import { render } from "./TemplateEditor.vue?vue&type=template&id=48b42e30&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"

import "./TemplateEditor.vue?vue&type=style&index=0&id=48b42e30&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b42e30"]])

export default __exports__